import React from 'react';
import { UrgencyBar } from './components/UrgencyBar';
import { HeroSection } from './components/HeroSection';
import { PainPoints } from './components/PainPoints';
import { SolutionSection } from './components/SolutionSection';
import { ProductContent } from './components/ProductContent';
import { BookPreviewCarousel } from './components/BookPreviewCarousel';
import { BonusSection } from './components/BonusSection';
import { PricingSection } from './components/PricingSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FAQSection } from './components/FAQSection';
import { FinalCTA } from './components/FinalCTA';
import { TestimonialsSection } from './components/TestimonialsSection';
import { Footer } from './components/Footer';
import { SocialProofPopup } from './components/SocialProofPopup';
export function App() {
  return <div className="min-h-screen bg-[#0a0a0a] text-white font-sans selection:bg-emerald-500/30 selection:text-emerald-200" data-id="element-0">
      <UrgencyBar data-id="element-1" />
      <main className="flex flex-col" data-id="element-2">
        <HeroSection data-id="element-3" />
        <PainPoints data-id="element-4" />
        <SolutionSection data-id="element-5" />
        <ProductContent data-id="element-6" />
        <BookPreviewCarousel data-id="element-7" />

        <BonusSection data-id="element-8" />
        <PricingSection data-id="element-9" />
        <GuaranteeSection data-id="element-10" />
        <FAQSection data-id="element-11" />
        <FinalCTA data-id="element-12" />
        <TestimonialsSection data-id="element-13" />
      </main>
      <Footer data-id="element-14" />
      <SocialProofPopup data-id="element-15" />
    </div>;
}